document.addEventListener("DOMContentLoaded", function () {
//   console.log("✅ DOMContentLoaded fired");
//   console.log("📂 Cart validation script started");

  function checkCartTotal() {
    // console.log("🔎 checkCartTotal() called");
    const totalElement = document.querySelector(".js-cart-subtotal .money");
    // console.log("📦 Selected total element:", totalElement);
    if (!totalElement) {
    //   console.log("❌ Total element NOT found, exiting function");
      return;
    }
    const totalText = totalElement.textContent.trim();
    // console.log("💷 Raw total text:", totalText);

    const numericValue = parseFloat(totalText.replace(/[^0-9.]/g, ""));
    // console.log("🔢 Parsed numeric value:", numericValue);

    if (isNaN(numericValue)) {
    //   console.log("❌ Parsed value is NaN, something is wrong");
      return;
    }

    if (numericValue === 0) {
    //   console.log("⚠️ Cart total is ZERO");
    //   console.log("🚨 Sending request to clear cart...");

      fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(function(response) {
        // console.log("📡 Response received from /cart/clear.js:", response);
        if (!response.ok) {
        //console.log("❌ Response not OK");
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then(function(data) {
        // console.log("🗑 Cart cleared successfully:", data);
        // console.log("🔄 Reloading page in 1 second...");
        setTimeout(function() {
          location.reload();
        }, 1000);
      })
      .catch(function(error) {
        // console.error("🔥 Error clearing cart:", error);
      });
    } else {
    //   console.log("✅ Cart total is greater than zero. No action taken.");
    }
  }
//   console.log("⏳ Waiting 1 second before checking cart...");
  setTimeout(function() {
    // console.log("🚀 Running initial cart check");
    checkCartTotal();
  }, 1000);

});
